import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Layout from "../../components/Layout";

// Api
import { getEvents } from "../../api/plan";

// Components
import LoadingPlaceholder from "../../components/LoadingPlaceholder";

// Images and mapping
import { imageMap } from "../MembershipPage/details";


const HomePage = () => {
  	const [isPageLoading, setIsPageLoading] = React.useState(true);
  	const [eventsData, setEventsData] = React.useState([]);

  	const getData = async () => {
      setIsPageLoading(true);
      const response = await getEvents();
      setEventsData(response?.data);
      setIsPageLoading(false);
    }

    useEffect(() => {
        getData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

  return (
    <Layout>
      <div className="bg-[#f5f3ee] min-h-screen flex flex-col items-center justify-center px-6 pb-24 py-12 lg:space-y-12 space-y-6">
        
        {/* Hero Section */}
        <div className="text-center max-w-3xl space-y-6">
          <h1 className="text-4xl md:text-6xl font-extrabold text-gray-900 leading-tight">
            Tixy ilə Tədbirə Düşmək Daha Rahatdır
          </h1>
          <p className="text-lg md:text-xl text-gray-600">
            Sevdiyiniz tədbirlərə, konsertlərə və festivallara bilet alın — sadə, sürətli və təhlükəsiz!
          </p>
        </div>
        
        {/* Events Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-6xl w-full">
          {isPageLoading ? <div className="py-5 col-span-2"><LoadingPlaceholder /></div> : eventsData?.items?.map(evt => (
            <Link
              key={evt._id}
              to={`/events/${evt._id}`}
              className="block bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition"
            >
              <div className="relative">
				  <div className="absolute bottom-3 right-3 w-6 h-6 border-2 border-white text-white text-[9px] font-semibold rounded-full flex items-center justify-center backdrop-blur-sm">
					{evt?.ageLimit}+
				</div>
                {/* Şəkil */}
                <img
                  src={imageMap[evt?._id]}
                  alt={evt.title}
                  className="w-full h-56 object-cover"
                />

                {/* Sağ yuxarıda tarix badge */}
                <div className="absolute top-3 right-3 bg-white text-black text-xs font-semibold px-3 py-1 rounded-full shadow-md">
                  📅 &nbsp;{evt?.date}
                </div>

                {/* Alt hissədə gradient overlay + məkan */}
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white px-4 py-2 text-sm">
                  📍 &nbsp;{evt?.place}
                </div>
              </div>

              {/* Aşağı hissə */}
              <div className="p-6 space-y-4">
                <h3 className="text-2xl font-bold text-gray-900">{evt.title}</h3>
                <div className="line-clamp-3" dangerouslySetInnerHTML={{__html: evt?.description}}></div>
                <div className="mt-4">
                  <span className="inline-block px-4 py-2 bg-black text-white rounded-lg text-base font-medium">
                    Bilet Al
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div>
          <h2 className="text-3xl font-bold text-gray-900 mt-8">Üstünlüklərimiz</h2>
        </div>
        
        {/* Features */}
        <div className="mt-5 grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl w-full">
          <div className="bg-white p-8 rounded-2xl shadow-md text-center hover:shadow-xl transition">
            <h3 className="text-2xl font-bold mb-4 text-gray-900">Premium Tədbirlər</h3>
            <p className="text-gray-600">K-pop, Jazz, Rock — ən böyük tədbirlər bir kliklə əlinizin altında.</p>
          </div>

          <div className="bg-white p-8 rounded-2xl shadow-md text-center hover:shadow-xl transition">
            <h3 className="text-2xl font-bold mb-4 text-gray-900">Təhlükəsiz Ödəniş</h3>
            <p className="text-gray-600">Ödənişləriniz 100% SSL qorunur, rahatlıqla alış-veriş edin.</p>
          </div>

          <div className="bg-white p-8 rounded-2xl shadow-md text-center hover:shadow-xl transition">
            <h3 className="text-2xl font-bold mb-4 text-gray-900">24/7 Dəstək</h3>
            <p className="text-gray-600">İstənilən sualınız üçün komandamız daim xidmətinizdədir.</p>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default HomePage;
